import { useState, useEffect } from 'react';

const CONTENT_BASE_URL = import.meta.env.VITE_CONTENT_BASE_URL || '/content';

const _cache = {};
const _promises = {};

function fetchPageContent(page) {
  if (_cache[page]) return Promise.resolve(_cache[page]);
  if (!_promises[page]) {
    _promises[page] = fetch(`${CONTENT_BASE_URL}/${page}.json?_t=${Date.now()}`)
      .then((r) => r.json())
      .then((json) => {
        _cache[page] = { components: json.components || [], meta: json._meta || {} };
        return _cache[page];
      })
      .catch(() => {
        delete _promises[page];
        return { components: [], meta: {} };
      });
  }
  return _promises[page];
}

export function usePageContent(page) {
  const cached = _cache[page];
  const [components, setComponents] = useState(cached?.components || []);
  const [meta, setMeta] = useState(cached?.meta || {});
  const [loaded, setLoaded] = useState(!!cached);

  useEffect(() => {
    fetchPageContent(page).then((data) => {
      setComponents(data.components);
      setMeta(data.meta);
      setLoaded(true);
    });
  }, [page]);

  const find = (type) => components.find((c) => c.type === type)?.content ?? undefined;

  return { find, components, meta, loaded };
}
